export enum LeadTopicType {
    PARKING = "PARKING",
    CUSTOM = "CUSTOM"
}
